var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field-map"},[_c('img',{staticClass:"map-preview",attrs:{"src":_vm.mapScreenshotUrl,"alt":"","role":"none"}})])}
var staticRenderFns = []

export { render, staticRenderFns }